import React from 'react';

import { QuestionarioContextProvider } from '../../../hooks/useQuestionario';
import Abas from './QuestionarioContratacao';

const Demandas = () => {
  return <QuestionarioContextProvider>{<Abas />}</QuestionarioContextProvider>;
};

export default Demandas;
